import { Link } from '@tanstack/react-router'
import { List, theme } from 'antd'
import { CampaignBadge } from './campaign-badge'
import React, { MouseEventHandler } from 'react'
import { CampaignSearchResponse } from '../../api'

export type CampaignSearchListItemProps = {
    campaign: CampaignSearchResponse
    onClick: MouseEventHandler
}

export function CampaignSearchListItem({ campaign, onClick }: CampaignSearchListItemProps) {
    const { token } = theme.useToken()

    return (
        <Link
            to="/campaigns/$campaignId/board"
            onClick={onClick}
            params={{ campaignId: campaign.id }}
        >
            <List.Item
                className="cursor-pointer"
                tabIndex={0}
                style={{
                    padding: `${token.paddingSM}px ${token.paddingMD}px`,
                }}
            >
                <List.Item.Meta
                    avatar={<CampaignBadge status={campaign.status} />}
                    title={campaign.title}
                />
            </List.Item>
        </Link>
    )
}
